import { Component, Input } from '@angular/core';
import { EntityModel } from '@data-layer/models/entities';
import { enumEntityModelCode } from '@data-layer/enums/entities';
import { EntityValidationHelper } from '@helpers/entity-validation.helper';

@Component({
  selector: 'app-card-step-body',
  templateUrl: './card-step-body.component.html',
  styleUrls: ['./card-step-body.component.scss'],
})
export class CardStepBodyComponent {
  @Input() public entity: EntityModel;
  @Input() public isShowIdentifierBlock: boolean = true;

  public enumEntityModelCode: typeof enumEntityModelCode = enumEntityModelCode;

  constructor() {}

  public getValidationText(fieldName: string) {
    return EntityValidationHelper.getEntityValidationText(this.entity, fieldName);
  }

  public isValidIsfEntityAddress(): boolean {
    return EntityValidationHelper.isValidEntityAddress(this.entity.address);
  }
}
